function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTools(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B086B"
    },
    d: "M49.5,180.8c-8.4,0-16.7-3.3-22.9-9.9c-11.8-12.6-11.1-32.4,1.5-44.2l63.2-59c1-0.9,2-1.7,3-2.5 c2.8-2,6.7-1.4,8.7,1.4c2,2.8,1.4,6.7-1.4,8.7c-0.6,0.5-1.2,1-1.8,1.5l-0.3,0.3l-62.9,58.7c-7.6,7.1-8,18.9-0.9,26.5 c7.1,7.6,18.9,8,26.5,0.9l63.2-59c2.5-2.4,6.5-2.2,8.8,0.3c2.4,2.5,2.2,6.5-0.3,8.8l-63.2,59C64.8,178,57.1,180.8,49.5,180.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B086B"
    },
    d: "M132.5,114.5c-3.4,0-6.2-2.7-6.2-6.1c-0.1-3.5,2.7-6.3,6.1-6.4c10.1-0.2,19-2.9,24.6-7.6 c6.3-5.3,10.3-14.1,10.6-23.2l-5,4c-4.6,3.8-10.4,5.5-16.4,4.9c-6-0.6-11.3-3.5-15.1-8.1c-3.8-4.6-5.5-10.4-4.9-16.4 c0.6-6,3.5-11.3,8.1-15.1l2.3-1.9c-0.2,0-0.4,0-0.7,0c-9.5,0-16.5,2.2-21.5,6.9c-6.1,5.6-10,15.3-10,24.7c0,3.5-2.8,6.2-6.2,6.2 c-3.5,0-6.2-2.8-6.2-6.2c0-12.9,5.4-25.9,14-33.9c7.3-6.8,17.4-10.2,30-10.2c5.9,0,11.7,1.2,17.1,3.5l10.3,4.3l-9.1,6.5 c-0.2,0.1-0.3,0.2-0.5,0.4l-11.6,9.4c-2,1.7-3.3,4-3.6,6.6s0.5,5.2,2.1,7.2s4,3.3,6.6,3.6c2.6,0.3,5.2-0.5,7.2-2.1l11.6-9.4 c0.4-0.3,0.8-0.7,1.2-1.1l7.4-8.4l3.3,10.7c1.3,4.2,1.9,8.5,1.9,12.9c0,6.2-1.3,12.6-3.8,18.4c-2.6,6.1-6.5,11.4-11.2,15.4 c-10.6,8.9-24.9,10.4-32.4,10.5C132.6,114.5,132.6,114.5,132.5,114.5L132.5,114.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B086B"
    },
    d: "M145.6,180.6c-5.8,0-11.6-2.4-15.7-7.1l-31.2-35.2c-2.3-2.6-2.1-6.5,0.5-8.8c2.6-2.3,6.5-2.1,8.8,0.5 l31.2,35.2c1.5,1.7,3.6,2.7,5.9,2.8c2.3,0.1,4.5-0.6,6.2-2.1c1.7-1.5,2.7-3.6,2.8-5.9c0.1-2.3-0.6-4.5-2.1-6.2l-32.2-36.3 c-2.3-2.6-2.1-6.5,0.5-8.8c2.6-2.3,6.5-2.1,8.8,0.5l32.2,36.3c7.7,8.7,6.9,22-1.8,29.7C155.6,178.8,150.6,180.6,145.6,180.6z  M41,59.2l9-8.7l34.2,35.2l-9,8.7L41,59.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B086B"
    },
    d: "M40.9,65.4c-0.7,0-1.4,0-2-0.1c-4.7-0.5-9-2.9-11.9-6.6l-5.5-6.9c-0.5-0.7-1.1-1.2-1.7-1.8 c-1.6-1.6-4.1-4.1-4-8.1c0.1-4.2,3.1-7.6,8.1-12.1c3.8-3.6,8.8-7.7,14.5-7.4c5.4,0.4,8.7,4.4,10.9,7.1l5.5,6.9 c6.1,7.7,4.9,18.9-2.8,25C48.8,64,45,65.4,40.9,65.4z M29.4,41.9c0.6,0.6,1.2,1.3,1.9,2.1l5.5,6.9c1.8,2.3,5.2,2.7,7.5,0.8 c1.1-0.9,1.8-2.1,2-3.6s-0.2-2.8-1.1-3.9l-5.5-6.9c-0.4-0.5-1.4-1.8-2.1-2.4c-0.6,0.3-2.2,1.1-5,3.8L32.4,39 C31,40.3,30,41.2,29.4,41.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B086B"
    },
    d: "M42.6,149.7c0,4.4,3.5,7.9,7.9,7.9c4.4,0,7.9-3.5,7.9-7.9c0,0,0,0,0,0c0-4.4-3.5-7.9-7.9-7.9 S42.6,145.4,42.6,149.7C42.6,149.7,42.6,149.7,42.6,149.7z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTools);
export default __webpack_public_path__ + "static/media/tools.0e40a794c079456c76449b223e1a0af1.svg";
export { ForwardRef as ReactComponent };